import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, onAuthStateChanged, User } from 'firebase/auth';
import { getFirestore, collection, getDocs, query, where, addDoc, setDoc, doc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDL3TC224PpKyVlrCtbTmimoBO3khw_yHQ",
  authDomain: "ofertium-arboles-navidad.firebaseapp.com",
  projectId: "ofertium-arboles-navidad",
  storageBucket: "ofertium-arboles-navidad.firebasestorage.app",
  messagingSenderId: "208095274963",
  appId: "1:208095274963:web:4aa3f7f55d6eba60b57126",
  measurementId: "G-D095PCD48Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Configuración inicial de autenticación
auth.useDeviceLanguage();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Lista de emails autorizados
const AUTHORIZED_EMAILS = [
  'hola@iznoval.com',
  // Añade aquí otros emails autorizados
];

// Admin check function
export const checkIsAdmin = async (uid: string): Promise<boolean> => {
  try {
    // Verificar si el usuario está autenticado
    const currentUser = auth.currentUser;
    if (!currentUser) return false;

    // Verificar si el email está en la lista de autorizados
    if (AUTHORIZED_EMAILS.includes(currentUser.email?.toLowerCase() || '')) {
      // Crear o actualizar el documento de admin
      const adminDocRef = doc(db, 'admins', uid);
      await setDoc(adminDocRef, {
        uid,
        email: currentUser.email,
        updatedAt: new Date()
      }, { merge: true });
      return true;
    }

    // Verificar en la base de datos
    const adminRef = collection(db, 'admins');
    const q = query(adminRef, where('uid', '==', uid));
    const querySnapshot = await getDocs(q);
    
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

// Admin activity logging
export const logAdminActivity = async (action: string, details: any) => {
  try {
    await addDoc(collection(db, 'adminLogs'), {
      action,
      details,
      adminId: auth.currentUser?.uid,
      adminEmail: auth.currentUser?.email,
      timestamp: new Date()
    });
  } catch (error) {
    console.error('Error logging admin activity:', error);
  }
};